export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Revoke on a later tick: starting a download from a blob URL is
  // asynchronous in some engines (WebKit/Safari can produce empty or failed
  // downloads when the URL is revoked in the same task), which is why
  // FileSaver-style helpers defer the revocation. Swallow throws — the URL
  // has served its purpose and the browser reclaims it.
  setTimeout(() => {
    try {
      URL.revokeObjectURL(url);
    } catch {
      // noop
    }
  }, 1000);
}
